import React, { createRef, RefObject } from "react"

interface Props {
  id?: string,
  type?: string,
  src: string,
  // TODO remaning script attributes
}

export class Script extends React.Component<Props> {
  div: RefObject<HTMLDivElement>;

  constructor(props) {
    super(props);
    this.div = createRef();
  }

  componentDidMount = ():void => {
    const node = document.createElement("script");
    node.type = this.props.type || "text/javascript";
    node.defer = true
    node.src = this.props.src;

    if (this.props.id)
      node.id = this.props.id;

    this.div.current?.appendChild(node);
  }

  render() {
    return <div ref={this.div}></div>;
  }
}
